export default {
  // Contract Management
  contractManagement: {
    title: 'Contract Management',
    description: 'Manage transportation contracts and agreements'
  },

  // Contracts Management
  contracts: {
    title: 'Contracts Management',
    description: 'Manage shipping company contracts and rate information',

    // Filters
    filters: {
      keyword: 'Keyword Search',
      keywordPlaceholder: 'Please enter carrier contract No., applicable commodity or NAC code',
      shipCompany: 'Shipping Company',
      shipCompanyPlaceholder: 'Select shipping company',
      contractNature: 'Contract Nature',
      contractNaturePlaceholder: 'Select contract nature',
      status: 'Status',
      statusPlaceholder: 'Select status',
      applicableCommodity: 'Applicable Commodity',
      applicableCommodityPlaceholder: 'Select applicable commodity',
      applicableRoute: 'Applicable Route',
      applicableRoutePlaceholder: 'Select applicable route',
      spaceGuarantee: 'Space Guarantee',
      spaceGuaranteePlaceholder: 'Select space guarantee',
      mqcRange: 'MQC Range',
      mqcMinPlaceholder: 'Min MQC',
      mqcMaxPlaceholder: 'Max MQC',
      effectiveDateRange: 'Valid Period',
      startDatePlaceholder: 'Start Date',
      endDatePlaceholder: 'End Date',
      nacCodes: 'NAC Codes',
      nacCodesPlaceholder: 'Please enter NAC code to search',
      contractNumber: 'Carrier Contract No.',
      contractNumberPlaceholder: 'Please enter carrier contract number'
    },

    // Status
    status: {
      enabled: 'Enabled',
      disabled: 'Disabled'
    },

    // Batch Actions
    batchActions: {
      operations: 'Batch Operations ({count})',
      selected: 'Selected {count} records',
      enable: 'Batch Enable',
      disable: 'Batch Disable'
    },

    // Toolbar
    toolbar: {
      batchExportExcel: 'Batch Export Excel',
      batchExportCsv: 'Batch Export CSV'
    },

    // Action Buttons
    actions: {
      add: 'Add Contract',
      edit: 'Edit',
      copy: 'Copy',
      enable: 'Enable',
      disable: 'Disable',
      delete: 'Delete'
    },

    // Add Contract
    add: {
      title: 'Add Contract',
      basicInfo: 'Basic Information',
      routeInfo: 'Applicable Routes',
      validityInfo: 'Validity Period',
      nacInfo: 'NAC Configuration',
      contractNumberPlaceholder: 'Enter company contract number',
      carrierPlaceholder: 'Select shipping company',
      pricingNaturePlaceholder: 'Select contract nature',
      commodityPlaceholder: 'Select applicable commodity',
      mqcPlaceholder: 'Enter MQC quantity (optional)',
      spaceGuaranteePlaceholder: 'Enter space guarantee (TEU/month), leave empty if not specified',
      routePlaceholder: 'Select applicable routes',
      effectiveDate: 'Effective Date',
      expiryDate: 'Expiry Date',
      validityPeriod: 'Validity Period',
      effectiveDatePlaceholder: 'Select effective date',
      expiryDatePlaceholder: 'Select expiry date',
      nacPlaceholder: 'Enter NAC (uppercase letters and numbers)',
      nacInputHint: 'Note: NAC can only contain uppercase letters and numbers, press Enter or blur to add',
      addNac: 'Add NAC',
      nacEmptyHint: 'Please add at least one NAC',
      statusPlaceholder: 'Select status',
      saveAndNew: 'Save & Add'
    },

    // Edit Contract
    edit: {
      title: 'Edit Contract',
      basicInfo: 'Basic Information',
      routeInfo: 'Applicable Routes',
      validityInfo: 'Validity Period',
      nacInfo: 'NAC Configuration',
      contractNumberPlaceholder: 'Enter company contract number',
      carrierPlaceholder: 'Select shipping company',
      pricingNaturePlaceholder: 'Select contract nature',
      commodityPlaceholder: 'Select applicable commodity',
      mqcPlaceholder: 'Enter MQC quantity (optional)',
      spaceGuaranteePlaceholder: 'Enter space guarantee (TEU/month), leave empty if not specified',
      routePlaceholder: 'Select applicable routes',
      effectiveDate: 'Effective Date',
      expiryDate: 'Expiry Date',
      effectiveDatePlaceholder: 'Select effective date',
      expiryDatePlaceholder: 'Select expiry date',
      nacPlaceholder: 'Enter NAC (uppercase letters and numbers)',
      nacInputHint: 'Note: NAC can only contain uppercase letters and numbers, press Enter or blur to add',
      addNac: 'Add NAC'
    },

    // Form Validation
    validation: {
      contractNumberRequired: 'Please enter company contract number',
      contractNumberLength: 'Contract number length should be between 1-50 characters',
      contractNumberExists: 'This contract number already exists, please use another one',
      carrierRequired: 'Please select shipping company',
      pricingNatureRequired: 'Please select contract nature',
      routeRequired: 'Please select applicable routes',
      commodityRequired: 'Please select applicable commodity',
      mqcRequired: 'Please enter MQC quantity',
      mqcRange: 'MQC quantity should be between 1-99999',
      spaceGuaranteeRequired: 'Please select space guarantee',
      spaceGuaranteeRange: 'Space guarantee should be between 0-999999',
      effectiveDateRequired: 'Please select effective date',
      expiryDateRequired: 'Please select expiry date',
      nacRequired: 'Please add at least one NAC',
      nacMinLength: 'Please add at least one NAC',
      nacFormatInvalid: 'Invalid NAC format, only uppercase letters and numbers are allowed',
      nacTooShort: 'NAC must be at least 2 characters long',
      nacAlreadyExists: 'This NAC already exists',
      statusRequired: 'Please select status'
    },

    // Table Columns
    columns: {
      shipCompanyNumber: 'Company Contract No.',
      applicableRoute: 'Applicable Route',
      shipCompany: 'Shipping Company',
      contractNature: 'Contract Nature',
      destinationName: 'Applicable Commodity',
      nacs: 'NAC',
      mqc: 'MQC',
      configuration: 'Space Guarantee',
      effectiveDate: 'Effective Date',
      status: 'Status'
    },

    // Table Tips
    table: {
      allRoutes: 'All applicable routes:',
      allNacs: 'All NACs:'
    },

    // Fields
    fields: {
      shipCompanyNumber: 'Company Contract No.',
      applicableRoute: 'Applicable Route',
      shipCompany: 'Shipping Company',
      contractNature: 'Contract Nature',
      destinationName: 'Applicable Commodity',
      nacs: 'NAC',
      mqc: 'MQC',
      configuration: 'Space Guarantee',
      effectiveDate: 'Effective Date',
      status: 'Status'
    },

    // Export
    export: {
      filename: 'Contract Management Data'
    },

    // Messages
    messages: {
      addSuccess: 'Contract added successfully',
      addFailed: 'Failed to add contract',
      updateSuccess: 'Contract updated successfully',
      expiryDateCleared: 'Expiry date cleared, please reselect',
      deleteSuccess: 'Contract deleted successfully',
      enabledSuccess: 'Enabled successfully',
      disabledSuccess: 'Disabled successfully',
      batchEnableSuccess: 'Batch enable successfully',
      batchDisableSuccess: 'Batch disable successfully',
      disabledFailed: 'Disable fail',
      selectEnableRecords: 'Please select records to enable first',
      selectDisableRecords: 'Please select records to disable first',
      copyInitiated: 'Copied to add page',
      copyDataLoaded: 'Copy data loaded successfully',
      copyFailed: 'Failed to copy data',
      saveFailedStatus: 'Failed to save contract: Server returned failure status',
      saveFailed: 'Failed to save contract',
      idRequired: 'Contract ID cannot be empty',
      fetchFailedEmpty: 'Failed to fetch contract details: Response is empty',
      fetchFailed: 'Failed to fetch contract details',
      updateFailedStatus: 'Failed to update contract: Server returned failure status',
      updateFailed: 'Failed to update contract'
    },

    // Detail Page and Modal
    detail: {
      title: 'Contract Details',
      basicInfo: 'Basic Information',
      routeInfo: 'Route Information',
      nacInfo: 'NAC Configuration',
      validityInfo: 'Validity & Status',
      noRoutes: 'No applicable routes',
      noNacs: 'No NAC configuration'
    },

    // Confirm Modal
    confirm: {
      title: 'Confirm Operation',
      deleteTitle: 'Confirm Delete',
      enableTitle: 'Confirm Enable',
      disableTitle: 'Confirm Disable',
      batchEnableTitle: 'Confirm Batch Enable',
      batchDisableTitle: 'Confirm Batch Disable',
      enableMessage: 'Are you sure to enable the selected {count} contracts?',
      disableMessage: 'Are you sure to disable the selected {count} contracts?',
      singleEnableMessage: 'Are you sure to enable this contract?',
      singleDisableMessage: 'Are you sure to disable this contract?',
      deleteMessage: 'Are you sure to delete contract "{number}"? This action cannot be undone.'
    }
  },

  // Contract Management Enum Translations
  enums: {
    // Pricing Nature Enum
    pricingNature: {
      selfPricing: 'FAK',
      customerPricing: 'Customer Pricing',
      overseasAgentPricing: 'Overseas Agent Pricing',
      noPricing: 'No Pricing',
      peerPricing: 'Peer Pricing',
      bcoContract: 'NAC/FIX',
      afcPricing: 'AFC Pricing',
      mixedPricing: 'Blended Pricing'
    },

    // Commodity Enum
    commodity: {
      fak: 'FAK',
      dangerousGoods: 'Dangerous Goods',
      specialContainer: 'Special Container',
      frozenGoods: 'Frozen Goods',
      chemicalGoods: 'Chemical Goods',
      textileGoods: 'Textile Goods',
      other: 'Other'
    },

    // Space Guarantee Enum
    spaceGuarantee: {
      guarantee20: 'Yes (20 TEU/Month)',
      guarantee50: 'Yes (50 TEU/Month)',
      guarantee100: 'Yes (100 TEU/Month)',
      guarantee300: 'Yes (300 TEU/Month)',
      noGuarantee: 'No'
    },

    // Contract Status Enum
    contractStatus: {
      enabled: 'Enabled',
      disabled: 'Disabled'
    }
  }
}
